import React, { useState } from "react"
import { InputReason, OrderDelivery } from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import { handleErrorMessages } from "helpers/errors"
import UPDATE_DELIVERY from "../../../../../graphql/mutations/order/deliveries/UpdateDelivery"
import { getDeliveryInput } from "../helpers"
import Reason from "../../Reason/Reason"
import { ReasonType } from "lib/types/order"
import { ReasonWrapper } from "./DeliveryReason.styled"
import { isSkipReason } from "../../../helpers"

type Props = {
  delivery: OrderDelivery
  refetch: () => void
  orderLoading: boolean
}

const DeliveryReason = ({ delivery, refetch, orderLoading }: Props) => {
  const [reasonType, setReasonType] = useState<ReasonType | undefined>(
    !delivery.reason ? ReasonType.SKIP : undefined
  )
  const [updateDelivery, { loading }] = useMutation(UPDATE_DELIVERY, {
    onCompleted: () => {
      setReasonType(ReasonType.SKIP)
      refetch()
    },
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const addReason = (reason: InputReason) => {
    updateDelivery({
      variables: {
        deliveryId: delivery.id,
        input: {
          ...getDeliveryInput(delivery),
          ...(reason.cause && reason.code && !isSkipReason(reasonType) && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateDelivery({
      variables: {
        deliveryId: delivery.id,
        input: {
          ...getDeliveryInput(delivery),
          reason: null
        }
      }
    })
  }

  return (
    <ReasonWrapper>
      <Reason
        orderReason={delivery.reason}
        addReason={addReason}
        reasonType={reasonType}
        setReasonType={setReasonType}
        loading={loading}
        removeReason={removeReason}
        orderLoading={orderLoading}
      />
    </ReasonWrapper>
  )
}

export default DeliveryReason
